import { createFileRoute } from '@tanstack/react-router';
import MyPoints from '../../components/client/MyPoints';
import ClientPortal from '../../components/portals/ClientPortal';
import { useAuth } from '../../contexts/AuthContext';
import { mockUser } from '../../data/mockData';

export const Route = createFileRoute('/client/points')({
  component: ClientPointsRoute,
});

function ClientPointsRoute() {
  const { user, isManager } = useAuth();
  const content = <MyPoints user={user && !isManager ? user : mockUser} />;
  return <ClientPortal>{content}</ClientPortal>;
}
